import React from "react";
import { Box, Typography, Container } from "@mui/material";

const RefundPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom textTransform="uppercase" fontWeight="bold">
          Refund Policy
        </Typography>

        <Typography variant="body1" paragraph>
          Thank you for choosing BizStor. Please read our refund policy carefully before subscribing to any of our plans. By using our service, you acknowledge and agree to the terms outlined below.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. General Refund Terms
        </Typography>
        <Typography variant="body1" paragraph>
          - All subscription payments are billed in advance and are generally non-refundable.<br />
          - We do not offer partial or pro-rated refunds for unused subscription periods, account downgrades, or cancellations made after billing.<br />
          - It is your responsibility to cancel your subscription before the next billing cycle if you no longer wish to use the service.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Exceptions and Refund Eligibility
        </Typography>
        <Typography variant="body1" paragraph>
          - In rare cases, we may offer a full or partial refund if a technical issue on our end prevents you from using the core features of BizStor for an extended period.<br />
          - Refund requests must be submitted within 14 days of the billing date to be considered.<br />
          - Refund processing may take up to 7–14 business days, depending on your payment method.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Service Downtime and Compensation
        </Typography>
        <Typography variant="body1" paragraph>
          - If system downtime exceeds 48 continuous hours due to internal issues, we may offer compensation in the form of a subscription extension, at our sole discretion.<br />
          - Compensation does not apply to downtime caused by scheduled maintenance, third-party services, or force majeure events.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Trial Period
        </Typography>
        <Typography variant="body1" paragraph>
          - All new users are eligible for a 1-month free trial with access to full platform features.<br />
          - No payment information is required during the trial, and no charges will be made unless a plan is selected after the trial ends.<br />
          - Once a paid plan is activated, the standard refund policy applies.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have questions or would like to request a refund, please contact our support team at: <strong>support@bizstor.lk</strong>
        </Typography>
        <Typography variant="body1" paragraph>
                  Last update: <strong>2026-07-14</strong>
                </Typography>
      </Box>
    </Container>
  );
};

export default RefundPolicy;
